import { ENVIRONMENT } from "../helper/getEnvVariables";

export const FOLLOW_TOPIC_TOAST_MESSAGE_COPY = "Topik diikuti";
export const MYBH_LINK = "mybh";
export const MANAGE_TOPICS_LINK = "manage/topics";

export const PUBLICATION = "bh";
export const BAAS_CLIENT_ENV = ENVIRONMENT;
